<template>
  <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="80">
    <FormItem label="时段名称" prop="shiftSegName">
      <Input v-model="form.shiftSegName" :maxlength="64"></Input>
    </FormItem>
    <FormItem label="工作时间" prop="worktime">
      <TimePicker type="timerange" v-model="form.worktime" placement="bottom-end" placeholder="请选择工作时间" style="width: 100%"></TimePicker>
    </FormItem>
    <FormItem label="休息时间" prop="resttime">
      <TimePicker type="timerange" v-model="form.resttime" placement="bottom-end" placeholder="请选择休息时间" style="width: 100%"></TimePicker>
    </FormItem>
    <FormItem>
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </FormItem>
  </Form>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        shiftSegName: [
          { required: true, message: '时段名称不能为空', trigger: 'blur,change' },
        ],
      },
      def: {},
      form: {
        id: null,
        shiftSegName: null,
        worktime: null,
        resttime: null,
      },
      id: null,
      loading: false,
      isCreate: true,
      modalVisible: false,
    }
  },

  props:{
    data:{
      type:Object,
      default:function(){
        return {

        }
      }
    }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑班段' : '新增班段'
    }
  },
  created() {
    this.def = { ...this.form }
    console.log(this.data)
    if( this.data ){
      this.form = this.data
    }
  },

  methods: {

    reset() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
    },

    save() {
      //
      let params = { ...this.form }
      this.$emit('ok' , params)
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleClose() {
      this.$emit('on-update')
    }
  }
}
</script>
